import { render } from "./ClaimDeviceScreen.vue?vue&type=template&id=6a8f2621"
import script from "./ClaimDeviceScreen.vue?vue&type=script&lang=js"
export * from "./ClaimDeviceScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__